import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import OfferDateType from '../../entities/booking/offerDateType';

interface OfferDateTypeState extends ListState<OfferDateType>{
    editOfferDateType:OfferDateType
}
class OfferDateTypeMutations extends ListMutations<OfferDateType>{

}
class OfferDateTypeModule extends ListModule<OfferDateTypeState,any,OfferDateType>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<OfferDateType>(),
        loading:false,
        editOfferDateType:new OfferDateType()
    }
    actions={
        async getAll(context:ActionContext<OfferDateTypeState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OfferDateType/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<OfferDateType>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<OfferDateTypeState,any>,payload:any){
            await Ajax.post('/api/services/app/OfferDateType/Create',payload.data);
        },
        async update(context:ActionContext<OfferDateTypeState,any>,payload:any){
            await Ajax.put('/api/services/app/OfferDateType/Update',payload.data);
        },
        async delete(context:ActionContext<OfferDateTypeState,any>,payload:any){
            await Ajax.delete('/api/services/app/OfferDateType/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<OfferDateTypeState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/OfferDateType/Get?Id='+payload.id);
            return reponse.data.result as OfferDateType;
        }
    };
    mutations={
        setCurrentPage(state:OfferDateTypeState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:OfferDateTypeState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:OfferDateTypeState,offerDateType:OfferDateType){
            state.editOfferDateType=offerDateType;
        }
    }
}
const offerDateTypeModule=new OfferDateTypeModule();
export default offerDateTypeModule;